
import React from 'react';
import Header from '@/components/Header';
import ReportCard from '@/components/reports/ReportCard';
import UsageInsightCard from '@/components/reports/UsageInsightCard';
import { recentReports, reportStatusColors, usageInsights } from '@/components/reports/mockData';

const Reports = () => {
  return (
    <div className="min-h-screen bg-gray-50 dark:bg-gray-900 overflow-auto">
      <Header />
      <main className="pt-24 pb-10 px-4 md:px-6 lg:px-8 max-w-7xl mx-auto">
        <div className="mb-8">
          <h1 className="text-3xl font-bold text-gray-900 dark:text-white">Energy Reports</h1>
          <p className="mt-2 text-lg text-gray-700 dark:text-gray-300">
            View and analyze your energy consumption reports
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          <ReportCard 
            reports={recentReports} 
            reportStatusColors={reportStatusColors} 
          />
          <UsageInsightCard insights={usageInsights} />
        </div>
      </main>
    </div>
  );
};

export default Reports;
